import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Util from '../../../utils/utils';
import {GN_APP_ID} from '../../../constant';
import moment from "moment";

const VerifySuccess = () => {
    const [redirectUrl, setRedirectUrl] = useState('')
    const [merchantName, setMerchantName] = useState("")
    const location = useLocation();
    const [min, setMin] = useState("0")
    const [sec, setSec] = useState("02")
    const [remainTime, setRemainTime] = useState(2)
    const timerId = useRef(false);
    const [bindingInfo, setBindingInfo] = useState({})

    useEffect(() => {
        document.title = 'Authorization Page';
        const params = location.state;
        if (!params) return;
        let bindingInfo = params.binding_info
        let data = params.data;
        console.log(params, params);

        const mcInfo = Util.getMerchantInfo(bindingInfo);
        setBindingInfo(bindingInfo);

        setMerchantName(mcInfo.merchant_name)
        if(bindingInfo.app_id){
          setRedirectUrl(bindingInfo.redirect_url +'?app_id=' + bindingInfo.app_id + "&auth_code=" + data.data.auth_code + "&binding_id=" + data.data.binding_id + "&identifier=" + data.data.identifier + "&binding_token=" + bindingInfo.binding_token  + "&status=" + 1)
        }
        if(bindingInfo.app_id === GN_APP_ID){
            setRedirectUrl(bindingInfo.redirect_url + "?authCode=" + data.data.auth_code + "&authState=" + bindingInfo.auth_state);
            timerId.current = setInterval(
                () => {
                    let min = moment().startOf('day').seconds(
                    remainTime).format(
                    'mm');
                    let sec = moment().startOf('day').seconds(
                    remainTime).format(
                    'ss');
                    
                    setRemainTime(remainTime => remainTime - 1);
                }, 1000
            )
            return () => {
                clearInterval(timerId.current);
            }
        }
    }, []);

    useEffect(() => {

        let min = moment().startOf('day').seconds(remainTime).format('mm');
        let sec = moment().startOf('day').seconds(remainTime).format('ss');
        setMin(min)
        setSec(sec)
  
        if (remainTime <= 0) {
          clearInterval(timerId.current)
          handlePickPrevious()
        }
    }, [remainTime])

    const handlePickPrevious = () => {
        // if(redirectUrl !== "")
        // window.location.href = redirectUrl;
    }
    return (
        <div className="zpbiding">
            <header id="header" hidden={true}>
                <div className="previous-page">
                    <a href="#"><img src="/img/default.svg" alt="arrow back"/></a>
                </div>
                <div className="title-page">{merchantName}</div>
                <div className="action-page"></div>
            </header>

            <div id="body-biding-status">

                <div className="top-status">
                    <p className="art-illus">
                        <img src="/img/accpet.svg" alt="success"/>
                    </p>
                    <h2 className="title-status">
                        Xác thực thành công liên kết <br/>Zalopay với {merchantName}
                    </h2>
                    <p className="wordbreak">{redirectUrl}</p>
                </div>
                <div className="bottom-status">
                    <div className="link-service">
                        <p>Xem và quản lý các dịch vụ liên kết tại mục</p>
                        <div className="steps">
                            <div className="step1">
                                <p><img src="/img/Canhan.svg" alt="canhan"/></p>
                                <p>Cá nhân</p>
                            </div>
                            <div className="step2">
                                <img src="/img/arrow_step.svg" alt="arrow"/>
                            </div>
                            <div className="step3">
                                <p><img src="/img/manager_link.svg" alt="link"/></p>
                                <p>Dịch vụ liên kết</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="space"></div>
                {(bindingInfo.app_id === GN_APP_ID) ? 
                <button className="btn btn-continue" onClick={handlePickPrevious}>Tiếp tục ({min}:{sec})</button>:
                <button className="btn btn-continue" onClick={handlePickPrevious}>Hoàn thành</button>
                }
            </div>
        </div>
    );
};

export default VerifySuccess;